import type { Pack, ProjectMeta } from '../../src/engine/schema.js';
import { inputs } from './inputs.js';
import { scenarios } from './scenarios.js';
import { comparators, metrics } from './metrics.js';
import { sources } from './sources.js';
import { narrative, narrativeCitations } from './narrative.js';

/**
 * Bump `dataVersion` on every substantive number change, and add a line to
 * CHANGELOG.md. Shared links carry the version they were made against, so a
 * screenshot in circulation can always be reconciled with a later correction.
 */
export const meta: ProjectMeta = {
  slug: 'pine-island',
  name: 'Project Skyway',
  place: 'Pine Island, Minnesota',
  tagline: 'A data center on 482 acres in Goodhue County, currently halted by court order.',
  dataVersion: 2,
  lastUpdated: '2026-08-07',
  defaultScenario: 'built',
  publisher: 'Project Clover, a project of Abundant America',
  publisherNote:
    'Built with publicly available data and stated assumptions. Every number links to its source and its arithmetic. Results are estimates, not forecasts or guarantees.',
};

export const pack: Pack = {
  meta,
  inputs,
  scenarios,
  metrics,
  comparators,
  sources,
  narrative,
  narrativeCitations,
};

export default pack;
